import React from "react";
import { useLanguage } from "../context/LanguageContext";
import { translations } from "../translations";

export const Industries = () => {
  const { language } = useLanguage();
  const t = translations.industries[language] || translations.industries.en;

  const industries = [
    { icon: "🏦", name: t.industry2, description: language === 'en' ? "Secure banking & fintech solutions" : language === 'hi' ? "सुरक्षित बैंकिंग और फिनटेक समाधान" : language === 'pa' ? "ਸੁਰੱਖਿਅਤ ਬੈਂਕਿੰਗ ਅਤੇ ਫਿਨਟੈਕ ਹੱਲ" : "Solutions bancaires sécurisées" },
    { icon: "🏥", name: t.industry1, description: language === 'en' ? "HIPAA-compliant medical apps" : language === 'hi' ? "HIPAA-अनुपालक मेडिकल ऐप्स" : language === 'pa' ? "HIPAA-ਅਨੁਕੂਲ ਮੈਡੀਕਲ ਐਪਸ" : "Apps médicales conformes" },
    { icon: "🛒", name: t.industry3, description: language === 'en' ? "Scalable online stores" : language === 'hi' ? "स्केलेबल ऑनलाइन स्टोर" : language === 'pa' ? "ਸਕੇਲੇਬਲ ਔਨਲਾਈਨ ਸਟੋਰ" : "Boutiques en ligne évolutives" },
    { icon: "🎓", name: t.industry4, description: language === 'en' ? "E-learning platforms" : language === 'hi' ? "ई-लर्निंग प्लेटफॉर्म" : language === 'pa' ? "ਈ-ਲਰਨਿੰਗ ਪਲੇਟਫਾਰਮ" : "Plateformes e-learning" },
    { icon: "🏗️", name: t.industry5, description: language === 'en' ? "Property management tools" : language === 'hi' ? "प्रॉपर्टी मैनेजमेंट टूल्स" : language === 'pa' ? "ਪ੍ਰਾਪਰਟੀ ਮੈਨੇਜਮੈਂਟ ਟੂਲਸ" : "Outils de gestion immobilière" },
    { icon: "🚚", name: t.industry6, description: language === 'en' ? "Supply chain solutions" : language === 'hi' ? "सप्लाई चेन समाधान" : language === 'pa' ? "ਸਪਲਾਈ ਚੇਨ ਹੱਲ" : "Solutions chaîne d'approvisionnement" },
    { icon: "🏭", name: t.industry7, description: language === 'en' ? "Industry 4.0 solutions" : language === 'hi' ? "इंडस्ट्री 4.0 समाधान" : language === 'pa' ? "ਇੰਡਸਟ੍ਰੀ 4.0 ਹੱਲ" : "Solutions Industrie 4.0" },
    { icon: "🎬", name: t.industry8, description: language === 'en' ? "Media & streaming apps" : language === 'hi' ? "मीडिया और स्ट्रीमिंग ऐप्स" : language === 'pa' ? "ਮੀਡੀਆ ਅਤੇ ਸਟ੍ਰੀਮਿੰਗ ਐਪਸ" : "Apps médias & streaming" }
  ];

  return (
    <section id="industries">
      <div className="container">
        <div className="section-header">
          <span className="section-label">{t.title}</span>
          <h2 className="section-title">{t.title}</h2>
          <p className="section-description">
            {t.subtitle}
          </p>
        </div>
        
        <div className="industries-grid">
          {industries.map((industry, i) => (
            <div key={i} className="industry-card">
              <span className="industry-icon">{industry.icon}</span>
              <h3>{industry.name}</h3>
              <p>{industry.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
